var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../runtime/Runtime';
import { QuestionTypeName } from '../learnware/LearnwareEnums';
export class EntityContext {
    entity_raw;
    constructor(entity) {
        makeObservable(this);
        this.entity_raw = entity;
    }
    get parent() {
        return this.entity_raw.parent;
    }
    get entity() {
        return this.entity_raw;
    }
    //  @computed
    get parentContext() {
        return (this.parent && this.parent.context) || (this.parent && this.parent.parent && this.parent.parent.context);
    }
    get solidParentContext() {
        return this.parentContext;
    }
    // @computed
    get app() {
        if (runtime.isBrowserRuntime) {
            return runtime.solidBrowserRuntime.app;
        }
        if (this.entity.type === 'app')
            return this.entity;
        const app = this.solidParentContext && this.solidParentContext.app;
        if (app)
            return app;
    }
    get topic() {
        return this.app.topic;
    }
    get solidTopic() {
        return this.topic;
    }
    get path() {
        return this.app.path;
    }
    get location() {
        return this.app.location;
    }
    get stage() {
        return this.app.stage;
    }
    get user() {
        return this.app.user;
    }
    //  @computed
    get questionParent() {
        if (this.entity.type === 'question')
            return this.entity;
        return this.parentContext && this.parentContext.question;
    }
    //   @computed
    get question() {
        if (this.entity.type === 'question')
            return this.entity;
        if (this.entity instanceof runtime.class.App)
            return this.entity.question || undefined;
        return this.parentContext && this.parentContext.question;
    }
    //  @computed
    get answer() {
        if (this.entity.type === 'answer')
            return this.entity;
        if (this.entity instanceof runtime.class.App)
            return this.entity.answer || undefined;
        return this.parentContext && this.parentContext.answer;
    }
    get solidQuestion() {
        return this.question;
    }
    get option() {
        if (this.entity.type === 'option')
            return this.entity;
        return this.parentContext && this.parentContext.option;
    }
    get image() {
        if (this.entity.type === 'image')
            return this.entity;
        return this.parentContext && this.parentContext.image;
    }
    get gap() {
        if (this.entity.type === 'gap')
            return this.entity;
        return this.parentContext && this.parentContext.gap;
    }
    get manner() {
        if (this.entity.type === 'manner')
            return this.entity;
        return this.parentContext && this.parentContext.manner;
    }
    get associateOption() {
        return this.option;
    }
    get multiSelectOption() {
        return this.option;
    }
    get questionAssociate() {
        return this.question;
    }
    get questionMultipleChoice() {
        return this.question;
    }
    get questionMemorizePoints() {
        return this.question;
    }
    get questionKnowAWord() {
        return this.question;
    }
    get questionSortable() {
        return this.question;
    }
    get questionInto() {
        return this.question;
    }
    get questionTalk() {
        return this.question;
    }
    get questionMultiSelect() {
        return this.question;
    }
    get association() {
        if (this.entity.type === 'association')
            return this.entity;
        return this.parentContext && this.parentContext.association;
    }
    get step() {
        if (this.entity.type === 'step')
            return this.entity;
        if (this.entity.type.includes('task'))
            return this.entity.step;
        if (this.entity.type === 'question') {
            const question = this.entity;
            if (question.task && question.orderedTask && question.orderedTask.step) {
                return question.orderedTask.step;
            }
            return null;
        }
        return this.parentContext && this.parentContext.step;
    }
    get orderedStep() {
        return this.step;
    }
    get orderedOption() {
        return this.option;
    }
    get task() {
        if (this.entity.type.includes('task'))
            return this.entity;
        if (this.entity.type === 'question')
            return this.entity.task;
        return this.parentContext && this.parentContext.task;
    }
    get wordTask() {
        return this.task;
    }
    get selectTask() {
        return this.task;
    }
    get multiSelectTask() {
        return this.task;
    }
    get memorizePointsWordTask() {
        if (this.question.questionType !== QuestionTypeName.MemorizePoints)
            return undefined;
        return this.task;
    }
    get readTask() {
        return this.task;
    }
    get orderedTask() {
        return this.task;
    }
    get sortableItem() {
        if (this.entity.type === 'sortableitem')
            return this.entity;
        return this.parentContext && this.parentContext.sortableItem;
    }
    get aspect() {
        if (this.entity.type === 'aspect')
            return this.entity;
        return this.parentContext && this.parentContext.aspect;
    }
    get actor() {
        if (this.entity.entityInfo.isActor)
            return this.entity;
        return this.solidParentContext.actor;
    }
    get parentActor() {
        return this.solidParentContext && this.solidParentContext.actor;
    }
    get mediaContext() {
        // if (['learnware'].includes(this.entity.type)) return this.actor.actorMedia.ownMediaSequenceContext;
        if (this.entity.type === 'app')
            return this.actor.actorMedia.ownMediaContext; // return { ...this.learnware.context.mediaSequenceContext };
        const parentActorContext = (this.parentActor && this.parentActor.context.mediaContext) || {};
        if (!(this.entity instanceof runtime.class.Actor))
            return parentActorContext;
        return { ...parentActorContext, ...this.actor.actorMedia.ownMediaContext };
    }
    byTag(tag) {
        this.question.importingTree.allImportingActors.find(actor => actor.tags.includes(tag));
    }
}
__decorate([
    computed
], EntityContext.prototype, "parentActor", null);
